/* Built In Imports */
import dynamic from 'next/dynamic';

/* External Imports */
import { Box } from '@chakra-ui/react';
// import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StyleConfig from '@landing_pages/eoe/Common/StyleConfig';
import TopBannerEvent from '@landing_pages/eoe/components/Banners/TopBannerEvent';
import BenefitsGroup from '@landing_pages/eoe/sections/BenefitsGroup';
import ContactUs from '@landing_pages/eoe/sections/ContactUs';
import EoeQuote from '@landing_pages/eoe/sections/EoeQuote';
import FaqSectionSIA from '@landing_pages/eoe/sections/FaqSectionSIA';
import FinancialSupport from '@landing_pages/eoe/sections/FinancialSupport';
import HowToReach from '@landing_pages/eoe/sections/HowtoReach';
import Offered from '@landing_pages/eoe/sections/Offered';
import ProgramDetailsEOE from '@landing_pages/eoe/sections/ProgramDetailsEOE';
import ProgramDetailsToronto from '@landing_pages/eoe/sections/ProgramDetailsToronto';
import ProgramDetailsTorontoSoon from '@landing_pages/eoe/sections/ProgramDetailsTorontoSoon';
import TestimonialsGroupV2 from '@landing_pages/eoe/sections/TestimonialsGroupV2';
import AdBanner from '@landing_pages/eoe/sections/AdBanner';
import { useEOEContext } from '@store/EOEContext';

/**
 * Renders Render Sadhguru In Aus Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Sadhguru In Aus Sections
 */

const RenderSections = ({
  section,
  region,
  lang,
  pType,
  csrData,
  pageData,
  mode,
  cityId,
  setCityId,
}) => {
  const sectionId = section?.sectionId;
  const { city } = useEOEContext();

  if (sectionId === 'top-banner') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <TopBannerEvent
          sectionContent={section.sectionContent[0]}
          sectionContent2={section.sectionContent[1]}
          section={section}
          region={region}
          language={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'offered') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <Offered section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (sectionId === 'eoe-quote') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <EoeQuote section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (sectionId === 'benefits') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <BenefitsGroup
          sectionContent={section.sectionContent}
          section={section}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'testimonials') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <Box display="flex" borderColor="transparent">
          <TestimonialsGroupV2
            testimonialsObj={section.sectionContent[0]}
            region={region}
            lang={lang}
          />
        </Box>
      </StyleConfig>
    );
  } else if (sectionId === 'program-details-eoe-toronto') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ProgramDetailsToronto
          section={section}
          region={region}
          lang={lang}
          pageData={pageData}
          setCityId={setCityId}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'program-details-eoe-toronto-soon') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ProgramDetailsTorontoSoon
          section={section}
          region={region}
          lang={lang}
          pageData={pageData}
          setCityId={setCityId}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'program-details-eoe') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ProgramDetailsEOE
          section={section}
          region={region}
          lang={lang}
          pageData={pageData}
          setCityId={setCityId}
        />
      </StyleConfig>
    );
  } else if (
    sectionId === 'faq-section' ||
    sectionId === `faq-section-${city}`
  ) {
    return (
      <StyleConfig
        id="faqs"
        key={section?.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <FaqSectionSIA
          sectionContent={section?.sectionContent}
          cityId={cityId}
        />
      </StyleConfig>
    );
  } else if (
    sectionId === `how-to-reach-${city}` ||
    sectionId === `how-to-reach`
  ) {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section?.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <HowToReach section={section} cityId={cityId} />
      </StyleConfig>
    );
  } else if (
    sectionId === `financial-support` ||
    sectionId === `financial-support-${city}`
  ) {
    return <FinancialSupport section={section} cityId={cityId} />;
  } else if (sectionId === `contact-us`) {
    return <ContactUs section={section} cityId={cityId} />;
  } else if (sectionId === `contact-us-city` && city) {
    return <ContactUs section={section} cityId={cityId} />;
  } else if (sectionId === 'sticky-button') {
    const RegisterStickyButton = dynamic(() =>
      import('@landing_pages/eoe/sections/RegisterStickyButton')
    );
    return (
      <RegisterStickyButton
        lang={lang}
        region={region}
        sectionContent={section.sectionContent}
      />
    );
  }
  else if (sectionId === 'ad-banner') {
    return (
      <AdBanner
        sectionContent={section.sectionContent[0]}
        region={region}
        lang={lang}
      />
    );
  }
};

export default RenderSections;
